const LEGAL_CONSENT_KEY = 'idcoder.legalConsent';

export type LegalConsent = {
  termsAccepted: boolean;
  privacyAccepted: boolean;
};

export function readLegalConsent(): LegalConsent {
  try {
    const raw = sessionStorage.getItem(LEGAL_CONSENT_KEY);
    if (!raw) return { termsAccepted: false, privacyAccepted: false };
    const parsed = JSON.parse(raw) as Partial<LegalConsent>;
    return {
      termsAccepted: !!parsed.termsAccepted,
      privacyAccepted: !!parsed.privacyAccepted,
    };
  } catch {
    return { termsAccepted: false, privacyAccepted: false };
  }
}

export function writeLegalConsent(consent: LegalConsent): void {
  sessionStorage.setItem(LEGAL_CONSENT_KEY, JSON.stringify(consent));
}

export function clearLegalConsent(): void {
  sessionStorage.removeItem(LEGAL_CONSENT_KEY);
}
